<template>
  <NoticeCard
    :class="b()"
  >
    <el-row
      type="flex"
      align="middle"
    >
      <div
        v-if="data.status !== 1"
        :class="b('uploading')"
      >
        <SymbolIcon
          icon="icondengdai"
          :size="30"
        />
        <div>
          <div :class="b('tips-title')">
            {{ $t('notice.dataProcessing') }}
          </div>
          <div :class="b('upload-tips-dec')">
            {{ $t('notice.other') }}
          </div>
          <el-progress
            :show-text="false"
            :stroke-width="4"
            :percentage="progressNum"
            style="margin-bottom: 12px;"
          >
          </el-progress>
        </div>
      </div>

      <div
        v-if="data.status === 1"
        :class="b('complete-have-fail')"
      >
        <div :class="b('tips-complete')">
          <SymbolIcon
            icon="iconchenggong1"
            :size="30"
          />
          <div :class="b('tips-complete-text')">
            <div :class="b('tips-title')">
              {{ $t('notice.importMembersNoticeCard.title') }}
            </div>
            <div :class="b('tips-num')">
              <template>
                <span v-html="importSuccessText" />
              </template>
              <template v-if="errorRow > 0">
                <span v-html="importFailText" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row
      type="flex"
      align="bottom"
    >
      <div v-if="data.status === 1">
        <el-button
          :class="b('continue-import')"
          size="mini"
          @click="openImportIssue(true)"
        >
          {{ $t('notice.importMembersNoticeCard.continue') }}
        </el-button>
        <el-button
          :class="b('action-submit')"
          type="primary"
          size="mini"
          @click="handleSubmit"
        >
          {{ errorRow > 0 ? $t('notice.importMembersNoticeCard.downloadErrorFile') : $t('notice.importMembersNoticeCard.yes') }}
        </el-button>
      </div>
    </el-row>
  </NoticeCard>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import NoticeCard from '@/components/notice/NoticeCard';
import { getOrgMemberImportResult } from '@/api/message';
import { debounce } from 'lodash';
import { exportMemberFails } from 'common-module/src/components/ImportMemberSteps/api';
import { downloadOfUrl, getObjectURL } from '@zk/framework-vue';
import { isOverseasVersion } from 'common-module/src/util';

export default {
  name: 'ImportMembersNoticeCard',
  components: {
    NoticeCard
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isProjectSettingPage: {
      type: Boolean,
      default: false
    },
    showImportMember: {
      type: Boolean,
      default: false
    },
    isProjectInviteMember: {
      type: Boolean,
      default: false
    }
  },
  bemNS: theme.bemNS,
  data() {
    return {
      startTimer: '',
      data: {},
      successRow: 0,
      errorRow: 0
    };
  },
  computed: {
    progressNum() {
      const { successRow, totalRow } = this.data || {};
      return parseInt((successRow / totalRow) * 100) > 100 ? 100 : parseInt((successRow / totalRow) * 100) || 0;
    },
    status() {
      return this.data?.status;
    },
    importSuccessText() {
      const num = this.data?.status === 1 ? this.successRow : this.totalRow;
      return this.$t('notice.importMembersNoticeCard.importSuccess', {
        successRow: this.$tc('common.count.member', num, {
          num: `<span class="${this.b('text-green')}">${num}</span>`
        })
      });
    },
    importFailText() {
      const num = this.errorRow;
      return this.$t('notice.importMembersNoticeCard.importFail', {
        errorRow: this.$tc('common.count.member', num, {
          num: `<span class="${this.b('text-red')}">${num}</span>`
        })
      });
    }
  },
  watch: {
    data: {
      handler(value, oldValue) {
        console.log('value', value, oldValue, value === oldValue);
        this.$parent.showClose = value.status === 1;
        if (value && value.status === 1) {
          this.errorRow = value.failCount;
          this.successRow = value.successCount;
          this.totalRow = value.totalCount;
          if (value.status === 1 && oldValue?.status !== 1) {
            //这里会接口超过500ms会重复调用
            this.eventBus.$emit('project:member-change');
            this.eventBus.$emit('member-list-change');
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.load();
    this.time();
  },
  destroyed() {
    clearTimeout(this.set);
  },
  methods: {
    time() {
      this.set = setTimeout(async() => {
        if (this.data.status !== 1) {
          await this.load();
          this.time();
        }
      }, 1000);
    },
    load: debounce(async function() {
      const res = await getOrgMemberImportResult(this.id);
      if (res) {
        this.data = res;
      }
    }, 500),
    handleClose(hasTrack) {
      this.$parent.close();
      if (hasTrack !== true) {
        return;
      }
      this.$track.send('Invite_BatchAddMember_UploadSuccess', {
        entry: this.isProjectSettingPage ? '组织成员-成员管理' :
          this.$route.fullPath === '/setting/members/group-manage' ? '组织成员-分组管理' : '左侧导航',
        SuccessAccount: this.successRow,
        FailAccount: this.errorRow,
        next_action: '关闭'
      }, true);
    },
    openImportIssue() {
      const eventMap = {
        settingOrg: 'setting:show-import-members-dialog',
        saasOrg: 'saas:show-import-members-dialog',
        project: 'project-show-invite-member'
      };
      const type = this.isProjectInviteMember ? 'project' : (this.isProjectSettingPage ? 'settingOrg' : 'saasOrg');
      this.eventBus.$emit(eventMap[type], this.showImportMember, 'inviteDirectAdd');
      this.$track.send('Invite_BatchAddMember_UploadSuccess', {
        entry: this.isProjectSettingPage ? '组织成员-成员管理' : '左侧导航',
        SuccessAccount: this.successRow,
        FailAccount: this.errorRow,
        next_action: '继续导入'
      }, true);
      setTimeout(() => {
        this.$parent.close(true);
      }, 500);

    },
    async downloadErrorFile() {
      if (this.errorRow > 0){
        const r = this.data.failList.map(item => {
          const r = {
            groupName: item.groupNames,
            memberEmail: item.email,
            memberName: item.userName,
            projectName: item.projectName,
            roleName: item.roleName
          };
          if (!isOverseasVersion) {
            r.memberPhone = item.phoneNumber;
          }

          return r;
        });
        const { result } = await exportMemberFails(r);
        const blobXLSX = new Blob([result], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }); // 更改文件格式为xlsx
        downloadOfUrl(
          getObjectURL(blobXLSX),
          this.$t('org.personnelMgr.inviteDialog.desc1')
        );
        this.$parent.close();
      }
    },
    async handleSubmit() {
      if (this.errorRow > 0) {
        await this.downloadErrorFile();
        return;
      }
      this.handleClose();
    }
  }
};
</script>

<style lang="scss">
@include b(import-members-notice-card) {
  // padding: 0 0 0 7px;
  .zk-import-members-notice-card__text-green {
    color: #0EB83A;
    margin: 0 !important;
  }
  .zk-import-members-notice-card__text-red {
    color: #E02020;
    margin: 0 !important;
  }
  svg {
    margin-right:  var(--m-small);
    flex-shrink: 0;
  }
  .zk-import-members-notice-card__uploading {
    display: flex;
    .zk-import-members-notice-card__upload-tips-dec {
      font-weight: var(--weight-font-Regular);
      color: var(--font-color-2);
      margin: 4px 0 12px 0;
    }
  }
  .zk-import-members-notice-card__tips-dec {
    font-weight: var(--weight-font-Regular);
    color: var(--font-color-1);
    margin: 4px 0 12px 0;
  }
  .zk-import-members-notice-card__tips-title {
    font-size: var(--size-font-6);
    font-weight: var(--notice-card-title-weight);
    line-height: 24px;
    color: var(--font-color-1);
  }
  .zk-import-members-notice-card__tips-complete {
    display: flex;
    .zk-import-members-notice-card__tips-num {
      font-weight: var(--weight-font-Regular);
      margin: 4px 0 12px 0;
      span {
        margin-right:  var(--m-small);
      }
    }
  }
  .zk-import-members-notice-card__tips-complete-text{
    .zk-import-members-notice-card__tips-dec {
      width: 100%;
      word-break: break-word;
    }
  }
  &:before {
    background-color: var(--main-bg-color);
  }
  // .el-button {
  //   height: 30px;
  // }
  .zk-import-members-notice-card__action-submit {
    margin-left: 12px;
  }
  .el-row--flex.is-align-bottom {
    justify-content: flex-end;
  }
}
</style>
